import React from "react";
import { Button } from "@/components/ui/button";
import { Link2, Unlink, CornerUpLeft } from "lucide-react";

export type DocumentMode = "amp" | "standalone";

interface DocumentModeToggleProps {
  /** null = följer projektets läge (endast när allowInherit) */
  value: DocumentMode | null;
  onChange: (mode: DocumentMode | null) => void;
  disabled?: boolean;
  /** Visar alternativet "Följ projektet" */
  allowInherit?: boolean;
  /** Projektets läge, visas som hjälptext när värdet ärvs */
  inheritedMode?: DocumentMode;
  label?: string;
}

export const DocumentModeToggle: React.FC<DocumentModeToggleProps> = ({
  value,
  onChange,
  disabled = false,
  allowInherit = false,
  inheritedMode = "amp",
  label
}) => {
  return (
    <div className="flex flex-wrap items-center gap-2">
      {label && (
        <span className="text-[11px] font-semibold uppercase tracking-[0.14em] text-muted-foreground">
          {label}
        </span>
      )}
      <div className="inline-flex items-center rounded-md border border-border bg-muted/40 p-0.5">
        {allowInherit && (
          <Button
            variant={value === null ? "secondary" : "ghost"}
            size="sm"
            className="gap-1.5 h-8"
            disabled={disabled}
            onClick={() => onChange(null)}
          >
            <CornerUpLeft className="h-3.5 w-3.5" /> Följ projektet
          </Button>
        )}
        <Button
          variant={value === "amp" ? "secondary" : "ghost"}
          size="sm"
          className="gap-1.5 h-8"
          disabled={disabled}
          onClick={() => onChange("amp")}
        >
          <Link2 className="h-3.5 w-3.5" /> Mot arbetsmiljöplan
        </Button>
        <Button
          variant={value === "standalone" ? "secondary" : "ghost"}
          size="sm"
          className="gap-1.5 h-8"
          disabled={disabled}
          onClick={() => onChange("standalone")}
        >
          <Unlink className="h-3.5 w-3.5" /> Fristående
        </Button>
      </div>
      {allowInherit && value === null && (
        <span className="text-xs text-muted-foreground">
          Följer projektets läge ({inheritedMode === "amp" ? "mot arbetsmiljöplan" : "fristående"})
        </span>
      )}
    </div>
  );
};

export default DocumentModeToggle;
